import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { createDraftCatalog as universalCreateDraftCatalog, publishDraftCatalog as universalPublishDraftCatalog, discardDraftCatalog as universalDiscardDraftCatalog, bulkCreateVariations as universalBulkCreateVariations, bulkUpdateItems as universalBulkUpdateItems, bulkCreateDishes as universalBulkCreateDishes, bulkCreateMenus as universalBulkCreateMenus, bulkUpdateMenus as universalBulkUpdateMenus, bulkCreateSections as universalBulkCreateSections, bulkUpdateSections as universalBulkUpdateSections, bulkArchiveMenus as universalBulkArchiveMenus, bulkUnarchiveMenus as universalBulkUnarchiveMenus, listCatalogs as universalListCatalogs, getMenu as universalGetMenu, getSection as universalGetSection, updateMenu as universalUpdateMenu, updateSection as universalUpdateSection, listMenus as universalListMenus, listSections as universalListSections, createMenu as universalCreateMenu, archiveMenu as universalArchiveMenu, unarchiveMenu as universalUnarchiveMenu, archiveSection as universalArchiveSection, removeDishFromSection as universalRemoveDishFromSection, createSection as universalCreateSection, getItem as universalGetItem, listItems as universalListItems, updateItem as universalUpdateItem, createDish as universalCreateDish, createVariation as universalCreateVariation, catalogsBulkCreateVariations as universalCatalogsBulkCreateVariations, catalogsBulkArchiveMenus as universalCatalogsBulkArchiveMenus, catalogsBulkCreateDishes as universalCatalogsBulkCreateDishes, catalogsBulkCreateSections as universalCatalogsBulkCreateSections, } from './restaurants-catalogs-v3-catalog.universal';
import { FulfillmentType, Platform, DayOfWeek, Type, ItemType, DiscountType, DiscountPlatform, SortOrder, WebhookIdentityType, } from './restaurants-catalogs-v3-catalog.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.restaurants.catalogs.v3.catalog', module_name: 'wix-restaurants-backend' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        createDraftCatalog: (catalogId) => {
            const methodLogData = {
                method_name: 'createDraftCatalog',
                service_name: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.createDraftCatalog',
            };
            return universalCreateDraftCatalog(catalogId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        publishDraftCatalog: (catalogId) => {
            const methodLogData = {
                method_name: 'publishDraftCatalog',
                service_name: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.publishDraftCatalog',
            };
            return universalPublishDraftCatalog(catalogId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        discardDraftCatalog: (catalogId) => {
            const methodLogData = {
                method_name: 'discardDraftCatalog',
                service_name: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.discardDraftCatalog',
            };
            return universalDiscardDraftCatalog(catalogId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkCreateVariations: (catalogId, options) => {
            const methodLogData = {
                method_name: 'bulkCreateVariations',
                service_name: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.bulkCreateVariations',
            };
            return universalBulkCreateVariations(catalogId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUpdateItems: (catalogId, options) => {
            const methodLogData = {
                method_name: 'bulkUpdateItems',
                service_name: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.bulkUpdateItems',
            };
            return universalBulkUpdateItems(catalogId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkCreateDishes: (catalogId, options) => {
            const methodLogData = {
                method_name: 'bulkCreateDishes',
                service_name: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.bulkCreateDishes',
            };
            return universalBulkCreateDishes(catalogId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkCreateMenus: (catalogId, options) => {
            const methodLogData = {
                method_name: 'bulkCreateMenus',
                service_name: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.bulkCreateMenus',
            };
            return universalBulkCreateMenus(catalogId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUpdateMenus: (catalogId, options) => {
            const methodLogData = {
                method_name: 'bulkUpdateMenus',
                service_name: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.bulkUpdateMenus',
            };
            return universalBulkUpdateMenus(catalogId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkCreateSections: (catalogId, options) => {
            const methodLogData = {
                method_name: 'bulkCreateSections',
                service_name: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.bulkCreateSections',
            };
            return universalBulkCreateSections(catalogId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUpdateSections: (catalogId, options) => {
            const methodLogData = {
                method_name: 'bulkUpdateSections',
                service_name: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.bulkUpdateSections',
            };
            return universalBulkUpdateSections(catalogId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkArchiveMenus: (catalogId, options) => {
            const methodLogData = {
                method_name: 'bulkArchiveMenus',
                service_name: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.bulkArchiveMenus',
            };
            return universalBulkArchiveMenus(catalogId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUnarchiveMenus: (catalogId, options) => {
            const methodLogData = {
                method_name: 'bulkUnarchiveMenus',
                service_name: 'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.bulkUnarchiveMenus',
            };
            return universalBulkUnarchiveMenus(catalogId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listCatalogs: (options) => {
            const methodLogData = {
                method_name: 'listCatalogs',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.listCatalogs',
            };
            return universalListCatalogs(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getMenu: (identifiers) => {
            const methodLogData = {
                method_name: 'getMenu',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.getMenu',
            };
            return universalGetMenu(identifiers, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getSection: (identifiers) => {
            const methodLogData = {
                method_name: 'getSection',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.getSection',
            };
            return universalGetSection(identifiers, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateMenu: (identifiers, options) => {
            const methodLogData = {
                method_name: 'updateMenu',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.updateMenu',
            };
            return universalUpdateMenu(identifiers, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateSection: (identifiers, options) => {
            const methodLogData = {
                method_name: 'updateSection',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.updateSection',
            };
            return universalUpdateSection(identifiers, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listMenus: (catalogId, options) => {
            const methodLogData = {
                method_name: 'listMenus',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.listMenus',
            };
            return universalListMenus(catalogId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listSections: (catalogId, options) => {
            const methodLogData = {
                method_name: 'listSections',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.listSections',
            };
            return universalListSections(catalogId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        createMenu: (catalogId, menu) => {
            const methodLogData = {
                method_name: 'createMenu',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.createMenu',
            };
            return universalCreateMenu(catalogId, menu, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        archiveMenu: (identifiers) => {
            const methodLogData = {
                method_name: 'archiveMenu',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.archiveMenu',
            };
            return universalArchiveMenu(identifiers, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        unarchiveMenu: (identifiers) => {
            const methodLogData = {
                method_name: 'unarchiveMenu',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.unarchiveMenu',
            };
            return universalUnarchiveMenu(identifiers, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        archiveSection: (identifiers) => {
            const methodLogData = {
                method_name: 'archiveSection',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.archiveSection',
            };
            return universalArchiveSection(identifiers, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        removeDishFromSection: (identifiers, itemId) => {
            const methodLogData = {
                method_name: 'removeDishFromSection',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.removeDishFromSection',
            };
            return universalRemoveDishFromSection(identifiers, itemId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        createSection: (identifiers, section) => {
            const methodLogData = {
                method_name: 'createSection',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.createSection',
            };
            return universalCreateSection(identifiers, section, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getItem: (identifiers, options) => {
            const methodLogData = {
                method_name: 'getItem',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.getItem',
            };
            return universalGetItem(identifiers, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listItems: (catalogId, options) => {
            const methodLogData = {
                method_name: 'listItems',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.listItems',
            };
            return universalListItems(catalogId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateItem: (identifiers, options) => {
            const methodLogData = {
                method_name: 'updateItem',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.updateItem',
            };
            return universalUpdateItem(identifiers, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        createDish: (identifiers, dish) => {
            const methodLogData = {
                method_name: 'createDish',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.createDish',
            };
            return universalCreateDish(identifiers, dish, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        createVariation: (catalogId, name) => {
            const methodLogData = {
                method_name: 'createVariation',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.createVariation',
            };
            return universalCreateVariation(catalogId, name, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        catalogsBulkCreateVariations: (catalogId, options) => {
            const methodLogData = {
                method_name: 'catalogsBulkCreateVariations',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.catalogsBulkCreateVariations',
            };
            return universalCatalogsBulkCreateVariations(catalogId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        catalogsBulkArchiveMenus: (catalogId, options) => {
            const methodLogData = {
                method_name: 'catalogsBulkArchiveMenus',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.catalogsBulkArchiveMenus',
            };
            return universalCatalogsBulkArchiveMenus(catalogId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        catalogsBulkCreateDishes: (catalogId, options) => {
            const methodLogData = {
                method_name: 'catalogsBulkCreateDishes',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.catalogsBulkCreateDishes',
            };
            return universalCatalogsBulkCreateDishes(catalogId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        catalogsBulkCreateSections: (catalogId, options) => {
            const methodLogData = {
                method_name: 'catalogsBulkCreateSections',
                service_name: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-restaurants-backend,entity=wix.restaurants.catalogs.v3.catalog,environment=velo-frontend,method-fqn=com.wixpress.restaurants.catalogs.v3.CatalogsApi.catalogsBulkCreateSections',
            };
            return universalCatalogsBulkCreateSections(catalogId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        FulfillmentType,
        Platform,
        DayOfWeek,
        Type,
        ItemType,
        DiscountType,
        DiscountPlatform,
        SortOrder,
        WebhookIdentityType,
    };
}
//# sourceMappingURL=restaurants-catalogs-v3-catalog.frontend.js.map